import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "./axiosInstance";
import "./managecontentstyle/ManageLessonActivities.css";
import { toast } from "react-toastify";
import EditLessonActivity from "./EditLessonActivity";
import { FormGroup, Label, Input, Button } from "reactstrap";
import AddActivityQuestion from "./AddActivityQuestion";
import { FaEdit, FaTrash, FaCopy, FaPlus } from "react-icons/fa";
import videoImage from "../images/video.png";
import quizImage from "../images/quiz.png";
import gameImage from "../images/game.png";
import oralImage from "../images/oral.png";
import mentalImage from "../images/mental.png";
import mcqImage from "../images/mcq.png";
import writtenImage from "../images/written.png";

const CopyActivity = ({ activity, handleCopyClose }) => {
  const [course, setCourse] = useState("");
  const [module, setModule] = useState("");
  const [lesson, setLesson] = useState("");
  const [courses, setCourses] = useState([]);
  const [modules, setModules] = useState([]);
  const [lessons, setLessons] = useState([]);

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = () => {
    axiosInstance
      .post("/api/managecontent/getAllCourses")
      .then((response) => {
        const sortedCourses = response.data.slice().sort((a, b) => {
          const coursenameA = a.coursename;
          const coursenameB = b.coursename;
          return coursenameA.localeCompare(coursenameB);
        });

        setCourses(sortedCourses);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchModules = (courseId) => {
    axiosInstance
      .post("/api/managecontent/getAllModule", { courseId })
      .then((response) => {
        const filteredModules = response.data.filter(
          (module) => module.Course_id === parseInt(courseId, 10)
        );
        setModules(filteredModules);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchLessons = (moduleId) => {
    axiosInstance
      .post("/api/managecontent/getAllLesson", { moduleId })
      .then((response) => {
        const filteredLessons = response.data.filter(
          (lesson) => lesson.Module_id === parseInt(moduleId)
        );
        setLessons(filteredLessons);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleCourseSelect = (courseId) => {
    setCourse(courseId);
    fetchModules(courseId);
  };

  const handleModuleSelect = (moduleId) => {
    setModule(moduleId);
    fetchLessons(moduleId);
  };

  const handleLessonSelect = (lessonId) => {
    setLesson(lessonId);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      Lesson_id: lesson,
      ActivityDescription: activity.ActivityDescription,
      ActivityLink: activity.ActivityLink,
      ActivityName: activity.ActivityName,
      ActivityType: activity.ActivityType,
      Instructions: activity.Instructions,
      OrderBy: activity.OrderBy,
      TotalTime: activity.TotalTime,
      Remarks: activity.Remarks,
      Score: activity.Score,
      originalActivityId: activity.Lesson_Activity_id
    };

    try {
      const response = await axiosInstance.post("/copyLessonActivityWithQuestions", payload);
      setCourse("");
      setModule("");
      setLesson("");
      toast.success("Lesson Activity and Questions have been Copied", {
        position: toast.POSITION.TOP_RIGHT,
      });
      handleCopyClose();
    } catch (error) {
      console.error(error);
      toast.error("Failed to copy activity and questions", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  return (
    <div className="modalStyle">
      <h2>Copy Lesson Activity</h2>
      <FormGroup>
        <Label for="course-select">Course</Label>
        <Input
          type="select"
          name="select"
          id="course-select"
          value={course}
          required
          onChange={(event) => handleCourseSelect(event.target.value)}
        >
          <option>Select a course</option>
          {courses.map((course) => (
            <option key={course.id} value={course.Course_id}>
              {course.coursename}
            </option>
          ))}
        </Input>
      </FormGroup>
      <FormGroup>
        <Label for="module-select">Module</Label>
        <Input
          type="select"
          name="select"
          id="module-select"
          value={module}
          required
          onChange={(event) => handleModuleSelect(event.target.value)}
        >
          <option>Select a Module</option>
          {modules.map((module) => (
            <option key={module.id} value={module.Module_id}>
              {module.modulename}
            </option>
          ))}
        </Input>
      </FormGroup>
      <FormGroup>
        <Label for="lesson-select">Lesson</Label>
        <Input
          type="select"
          name="select"
          id="lesson-select"
          value={lesson}
          required
          onChange={(event) => handleLessonSelect(event.target.value)}
        >
          <option>Select a Lesson</option>
          {lessons.map((lesson) => (
            <option key={lesson.id} value={lesson.Lesson_id}>
              {lesson.lessonname}
            </option>
          ))}
        </Input>
      </FormGroup>
      <div className="">
        <Button
          variant="primary"
          onClick={handleSubmit}
          className="save-button"
        >
          Save
        </Button>
        <Button
          variant="primary"
          onClick={handleCopyClose}
          className="save-button twobutton"
        >
          Close
        </Button>
      </div>
    </div>
  );
};

const ActivityCard = ({ activity, handleDelete, handleEdit, handleAssign, onEditClick, onCopyClick, onAddQuestionClick }) => {
  const handleCopyActivity = () => {
    onCopyClick(activity);
  };

  const handleEditClick = () => {
    onEditClick(activity);
  };

  const handleAddQuestion = () => {
    onAddQuestionClick(activity);
  };

  const getActivityImage = (activityType) => {
    const images = {
      "Oral": oralImage,
      "Video": videoImage,
      "Speed Quiz": quizImage,
      "Written": writtenImage,
      "Mental": mentalImage,
      "Game": gameImage,
      "MCQ": mcqImage,
    };
    return images[activityType] || null;
  };

  return (
    <div
      className="activity-card"
      key={activity.Lesson_Activity_id}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div style={{ flex: "0 0 20%" }}>
        <img
          src={getActivityImage(activity.ActivityType)}
          alt={activity.ActivityType}
          style={{ width: "50px", height: "50px" }}
        />
      </div>
      <div style={{ flex: "0 0 50%", marginLeft: "5px" }}>
        {activity.ActivityName}
      </div>
      <div
        className="icons-container"
        style={{ flex: "0 0 30%", cursor: "pointer" }}
      >
        {activity.ActivityType !== "Game Activity" &&
          activity.ActivityType !== "Video Activity" && (
            <>
              <FaPlus
                className="add-icon"
                onClick={handleAddQuestion}
              />
            </>
          )}
           <FaEdit className="edit-icon" onClick={handleEditClick} />
        <FaTrash
          className="delete-icon"
          onClick={() => handleDelete(activity.Lesson_Activity_id)}
        />
        <FaCopy className="assign-icon" onClick={handleCopyActivity} />
      </div>
    </div>
  );
};

const ManageLessonActivities = (props) => {
  const [activities, setActivities] = useState([]);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isCopyActivityOpen, setCopyActivityOpen] = useState(false);
  const [isAddQuestionActive, setAddQuestion] = useState(false);
  const [selectedActivityForEdit, setSelectedActivityForEdit] = useState(null);
  const [selectedActivityForCopy, setSelectedActivityForCopy] = useState(null);
  const [selectedActivityForQuestion, setSelectedActivityForQuestion] = useState(null);
  const editModalRef = useRef(null);
  const copyModalRef = useRef(null);
  const addQuestionModalRef = useRef(null);

  const lesson = props.lessonid;

  useEffect(() => {
    fetchLessonActivities();
  }, []);

  // Click outside to close modals
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (editModalRef.current && !editModalRef.current.contains(event.target)) {
        closeEditModal();
      }
      if (copyModalRef.current && !copyModalRef.current.contains(event.target)) {
        closeCopyModal();
      }
      if (addQuestionModalRef.current && !addQuestionModalRef.current.contains(event.target)) {
        closeAddQuestionModal();
      }
    };

    if (isEditModalOpen || isCopyActivityOpen || isAddQuestionActive) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isEditModalOpen, isCopyActivityOpen, isAddQuestionActive]);

  const fetchLessonActivities = () => {
    axiosInstance
      .post("/getLessonActivities", { lesson })
      .then((response) => {
        setActivities(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [isAssignFormOpen, setIsAssignFormOpen] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const [selectedLesson, setSelectedLesson] = useState("");

  const [newActivityName, setNewActivityName] = useState("");
  const [newActivityDescription, setNewActivityDescription] = useState("");

  const [courses, setCourses] = useState([]);
  const [modules, setModules] = useState([]);
  const [lessons, setLessons] = useState([]);

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = () => {
    axiosInstance
      .post("/api/managecontent/getAllCourses")
      .then((response) => {
        const sortedCourses = response.data.slice().sort((a, b) => {
          const coursenameA = a.coursename;
          const coursenameB = b.coursename;
          return coursenameA.localeCompare(coursenameB);
        });

        setCourses(sortedCourses);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchModules = (courseId) => {
    axiosInstance
      .post("/api/managecontent/getAllModule", { courseId })
      .then((response) => {
        const filteredModules = response.data.filter(
          (module) => module.Course_id === parseInt(courseId, 10)
        );
        setModules(filteredModules);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchLessons = (moduleId) => {
    axiosInstance
      .post("/api/managecontent/getAllLesson", { moduleId })
      .then((response) => {
        const filteredLessons = response.data.filter(
          (lesson) => lesson.Module_id === parseInt(moduleId)
        );
        setLessons(filteredLessons);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleCourseSelect = (courseId) => {
    setCourses(courseId);
    fetchModules(courseId);
  };

  const handleModuleSelect = (moduleId) => {
    setModules(moduleId);
    fetchLessons(moduleId);
  };

  const handleLessonSelect = (lessonId) => {
    setLessons(lessonId);
  };

  // Modal handlers
  const handleEditClick = (activity) => {
    setSelectedActivityForEdit(activity);
    setEditModalOpen(true);
  };

  const handleCopyClick = (activity) => {
    setSelectedActivityForCopy(activity);
    setCopyActivityOpen(true);
  };

  const handleAddQuestionClick = (activity) => {
    setSelectedActivityForQuestion(activity);
    setAddQuestion(true);
  };

  const closeEditModal = () => {
    setEditModalOpen(false);
    setSelectedActivityForEdit(null);
  };

  const closeCopyModal = () => {
    setCopyActivityOpen(false);
    setSelectedActivityForCopy(null);
  };

  const closeAddQuestionModal = () => {
    setAddQuestion(false);
    setSelectedActivityForQuestion(null);
  };

  const handleEdit = (activityId) => {
    const activityToEdit = activities.find(
      (activity) => activity.Lesson_Activity_id === activityId
    );
    if (activityToEdit) {
      setNewActivityName(activityToEdit.name);
      setNewActivityDescription(activityToEdit.description);
      setSelectedActivity(activityId);
      setSelectedCourse("");
      setSelectedModule("");
      setSelectedLesson("");
      setIsAssignFormOpen(true);
    }
  };

  const handleAdd = () => {
    setSelectedActivity(null);
    setIsAssignFormOpen(true);
  };

  const handleDelete = (activityId) => {
    setActivities(
      activities.filter(
        (activity) => activity.Lesson_Activity_id !== activityId
      )
    );
    const payload = { Lesson_Activity_id: activityId };
    axiosInstance
      .post("/api/managecourse/deleteLessonActivity", payload)
      .then(() => {
        toast.success("Lesson Activity Deleted", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((error) => {
        console.log("Internal server error", error);
      });
  };

  const handleAssign = (activityId) => {
    setSelectedActivity(activityId);
    setSelectedCourse("");
    setSelectedModule("");
    setSelectedLesson("");
    setIsAssignFormOpen(true);
  };

  const handleSaveAssign = () => {
    // Handle save assign functionality
    setIsAssignFormOpen(false);
    setSelectedActivity(null);
    setSelectedCourse("");
    setSelectedModule("");
    setSelectedLesson("");
  };

  const handleSaveActivity = () => {
    if (selectedActivity) {
      // Edit existing activity
      setActivities((prevActivities) =>
        prevActivities.map((activity) => {
          if (activity.Lesson_Activity_id === selectedActivity) {
            return {
              ...activity,
              name: newActivityName,
              description: newActivityDescription,
            };
          }
          return activity;
        })
      );
    } else {
      // Add new activity
      const newActivity = {
        id: Math.floor(Math.random() * 1000),
        name: newActivityName,
        description: newActivityDescription,
      };
      setActivities((prevActivities) => [...prevActivities, newActivity]);
    }

    setIsAssignFormOpen(false);
    setSelectedActivity(null);
    setNewActivityName("");
    setNewActivityDescription("");
  };

  return (
    <div className="manage-lesson-activities">
      <h1>Manage Lesson Activities</h1>
      <div className="activity-list">
        {activities.map((activity) => (
          <ActivityCard
            key={activity.Lesson_Activity_id}
            activity={activity}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleAssign={handleAssign}
            onEditClick={handleEditClick}
            onCopyClick={handleCopyClick}
            onAddQuestionClick={handleAddQuestionClick}
          />
        ))}
      </div>

      {/* Edit Lesson Activity Modal */}
      {isEditModalOpen && selectedActivityForEdit && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div ref={editModalRef} className="modal-content" style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            maxWidth: '90%',
            maxHeight: '90%',
            overflow: 'auto',
            position: 'relative'
          }}>
            <EditLessonActivity
              activity={selectedActivityForEdit}
              handleClose={closeEditModal}
            />
          </div>
        </div>
      )}

      {/* Copy Activity Modal */}
      {isCopyActivityOpen && selectedActivityForCopy && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div ref={copyModalRef} className="modal-content" style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            maxWidth: '90%',
            maxHeight: '90%',
            overflow: 'auto',
            position: 'relative'
          }}>
            <CopyActivity
              activity={selectedActivityForCopy}
              handleCopyClose={closeCopyModal}
            />
          </div>
        </div>
      )}

      {/* Add Question Modal */}
      {isAddQuestionActive && selectedActivityForQuestion && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div ref={addQuestionModalRef} className="modal-content" style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            maxWidth: '90%',
            maxHeight: '90%',
            overflow: 'auto',
            position: 'relative'
          }}>
            <AddActivityQuestion
              activityID={selectedActivityForQuestion.Lesson_Activity_id}
              handleClose={closeAddQuestionModal}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageLessonActivities;
